import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  Image,
  Text,
} from "@chakra-ui/react";
import { isNotEmptyOrNull } from "../../../utils/common-utils";
import { useEffect, useState } from "react";
import SubjectSelector from "../SubjectSelector/SubjectSelector";
import {
  getSectionSubjectTree,
  getSectionSubjectTreeV3,
} from "../../../network/LearnApiService";
import { learnSideNavStyles } from "./learnSideNavStyles";
import { useRoot } from "../../../context/RootContext";
import { useTutor } from "../../../context/AiTutorContext";
import { SubjectSelectorStyles } from "../SubjectSelector/SubjectSelectorStyles";
import ErrorSubtopicsImg from "../../../assets/svgs/learnSideNavNoTopics.svg";
import MultiProgressLoading from "../../../assets/lotties/MultiProgressLoading.json";
import Lottie from "react-lottie-player";
import useStateRef from "react-usestateref";
import { StorageService } from "../../../utils/StorageUtils";

const LearnSideNav = ({
  data,
  onClose,
  onSubtopicClick,
  isOpen,
  isReviewScreen = false,
  subjectMasterUuid = "",
  topicMasterUuid = "",
}) => {
  const { setSubTopicName, selectedIndex, setSelectedIndex } = useRoot();
  const [subjectsList, setSubjectsList] = useState([]);
  const [latestTasksList, setLatestTasksList] = useState([]);
  const [
    customAssessmentTopicsUnlockedList,
    setCustomAssessmentTopicsUnlockedList,
  ] = useState([]);
  const [mainTopic, setMainTopic] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [
    userAdditionalDetails,
    setUserAdditionalDetails,
    userAdditionalDetailsRef,
  ] = useStateRef({});

  const [width, setWidth] = useState(0);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const setSelectedSubtopic = () => {};
  const { selectedTopic, setSelectedSubTopic } = useTutor();

  useEffect(() => {
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);

    if (details) {
      setUserAdditionalDetails(details);
    }
  }, []);

  const onTopicSelector = (selectedSubtopic) => {
    setSubTopicName(selectedSubtopic?.name);
    setSelectedSubTopic(selectedSubtopic);
    // onSubtopicClick();
  };

  const getSubjectsData = async () => {
    setIsLoading(true); // Start loading
    let subjects = [];
    let latestTasks = [];
    let customSubtopicTopics = [];

    let payload = {
      schoolId: userAdditionalDetailsRef?.current?.schoolId,
      gradeId: userAdditionalDetailsRef?.current?.schoolGradeId,
      sectionId: userAdditionalDetailsRef?.current?.sectionId,
      academicYearId: userAdditionalDetailsRef?.current?.academicYearId,
    };

    const {
      latestTasks: latesttasks,
      subjects: fetchedSubjects,
      customSubtopicTopics: customsubtopictopics,
    } = await getSectionSubjectTreeV3(payload);
    latestTasks = latesttasks;
    subjects = fetchedSubjects;
    customSubtopicTopics = customsubtopictopics;

    setSubjectsList(subjects);
    setLatestTasksList(latestTasks);
    setCustomAssessmentTopicsUnlockedList(customSubtopicTopics);

    let mainSubject, topicDetails, mainTopic;

    mainSubject = subjects?.find(
      (sub) => sub?.master_uuid === subjectMasterUuid
    );

    topicDetails = mainSubject?.topicDetails;

    mainTopic = topicDetails?.find(
      (topic) => topic?.topic?.topicMasterUuid === topicMasterUuid
    );

    setMainTopic(mainTopic);
    setIsLoading(false); // End loading
  };

  useEffect(() => {
    if (
      isOpen &&
      isNotEmptyOrNull(subjectMasterUuid) &&
      isNotEmptyOrNull(topicMasterUuid)
    ) {
      getSubjectsData();
    }
  }, [isOpen]);

  const isMobile = width <= 768;
  const sizes = ["md"];

  const handleCloseSideNav = () => {
    if (isOpen) {
      onClose();
    }
  };

  return (
    <Drawer
      isOpen={isOpen}
      placement={isMobile ? "bottom" : "right"}
      onClose={onClose}
      size={sizes}
    >
      <DrawerContent sx={learnSideNavStyles(isMobile)?.drawerContentStyle}>
        <DrawerCloseButton />
        <DrawerBody sx={learnSideNavStyles().drawerBodyStyle}>
          <Box sx={SubjectSelectorStyles(true, "")?.sideNavHeader}>
            My Journey
          </Box>

          {isLoading && (
            <Box sx={learnSideNavStyles()?.loadingContainer}>
              <Lottie
                animationData={MultiProgressLoading}
                play
                loop
                style={{
                  width: "100%",
                  height: "70%",
                }}
              />
            </Box>
          )}
          {!isLoading && !isNotEmptyOrNull(mainTopic) && (
            <Box>
              <Image src={ErrorSubtopicsImg} />
              <Text sx={learnSideNavStyles()?.errorSubtopicsTitle}>
                Error Fetching Subtopics
              </Text>
              <Text sx={learnSideNavStyles()?.errorSubtopicsDescription}>
                We’re on It – Just a Moment!
              </Text>
            </Box>
          )}
          {!isLoading && isNotEmptyOrNull(mainTopic) && (
            <SubjectSelector
              onTopicSelector={onTopicSelector}
              key={selectedTopic?.topic?.topicId}
              setSelectedSubtopic={setSelectedSubtopic}
              selectedSubtopic={mainTopic}
              topics={mainTopic}
              mode={""}
              isLearn={false}
              isSideNav={true}
              latestTasksList={latestTasksList}
              onClickFromSubjectSelector={onSubtopicClick}
              onSelfLearnButtonClick={handleCloseSideNav}
              customAssessmentTopicsUnlockedList={
                customAssessmentTopicsUnlockedList
              }
            />
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default LearnSideNav;
